<template>
  <v-row data-qa="noticecashisacloseaccount-row-394mta">
    <v-col data-qa="noticecashisacloseaccount-col-iouofk">
      <NoticeCashIsaCloseAccountHeader
        :account-number="params.accountId"
        :currency="params.currency"
        :balance="params.balance"
        :account-type="params.accountType"
      />
      <!-- View details -->
      <v-flex class="text-left mt-2 mb-2" data-qa="noticecashisacloseaccount-flex-rsdrxp">
        <v-btn
          text
          :color="primaryColor"
          @click="gotoAccountDetails"
          class="py-2 px-4 text-capitalize"
          data-qa="noticecashisacloseaccount-btn-f6e1i">
          <v-icon left size="18px" class="material-symbols-outlined" data-qa="noticecashisacloseaccount-icon-7jpp98">arrow_left_alt</v-icon>
          {{ text.viewDetails }}
        </v-btn>
      </v-flex>

      <!-- Close Acount Card -->
      <v-card class="pa-6" width="830" elevation="2" v-if="!showForecast" data-qa="noticecashisacloseaccount-card-h4euu">
        <p class="title font-weight-bold text-capitalized" data-qa="noticecashisacloseaccount-p-aqa7">
          {{ text.closureTitle }}
        </p>

        <v-container class="pl-6" data-qa="noticecashisacloseaccount-container-ukbl9v">
          <template v-if="!closeWithoutNotice">
            <span data-qa="noticecashisacloseaccount-span-hdb4zv" v-if="!isBalanceZero">
              {{ text.yourAccoutWouldClose }}
            </span>
            <v-container class="pl-6" data-qa="noticecashisacloseaccount-container-khogos">
              <p class="text-uppercase mb-1" :color="primaryColor" v-if="!isBalanceZero" data-qa="noticecashisacloseaccount-p-g6guhm">
                {{ text.noticeWthdrawalDate }}</p>
              <p class="font-weight-bold text-h6 mb-1" v-if="!isBalanceZero" data-qa="noticecashisacloseaccount-p-eay9i">
                {{ params.withdrawalDateDisplay }}</p>
                <v-checkbox data-qa="noticecashisacloseaccount-checkbox-5hv0f7"
                  v-model="closeWithoutNotice"
                  :color="primaryColor"
                  :disabled="isBalanceZero"
                  :label="text.closeWithoutNotice"
                />
            </v-container>
          </template>

          <v-checkbox data-qa="noticecashisacloseaccount-checkbox-i4aedo"
            v-if="closeWithoutNotice"
            v-model="closeWithoutNotice"
            :color="primaryColor"
            :disabled="isBalanceZero"
            :label="text.closeWithoutNotice"
          />
          <span data-qa="noticecashisacloseaccount-span-1d49xq"  v-text="text.closurePayawayNote" class="mt-2"/>
          <NoticeCashIsaSelectPayaway
            v-model="selectedPayaway"
            :same-bank-accounts="sameBankAccounts"
            :other-bank-accounts="otherBankAccounts"
            class="mt-2"
          />
          <v-autocomplete data-qa="noticecashisacloseaccount-autocomplete-fvd1g"
            v-if="config.showReasonForClosure"
            class="pt-6"
            v-model="selectedReason"
            :items="reasons"
            :label="text.reasonForClosure"
            :color="primaryColor"
            return-object
            :rules="[rules.required]"
          />
          <v-text-field data-qa="noticecashisacloseaccount-text-field-6ny1sh"
            v-else
            v-model="remarks"
            :label="text.remarks"
            class="pt-6"
            required
            :color="primaryColor"
            :rules="[rules.required]"
          />
        </v-container>
        <v-row class="justify-start" data-qa="noticecashisacloseaccount-row-92h9vh">
        <v-card-actions data-qa="noticecashisacloseaccount-card-actions-8k49yo">
          <v-spacer data-qa="noticecashisacloseaccount-spacer-ucnx9v"  />
          <v-btn data-qa="noticecashisacloseaccount-btn-m9mn6"
            @click="gotoReview"
            :color="primaryColor"
            class="text-capitalize white--text py-2 px-4"
            :disabled="!canProceed"
            v-text="text.proceed"
            style="margin-left: 32px;"
          />
        </v-card-actions>
        </v-row>
      </v-card>

      <!-- Review or forecast screen -->
      <v-card class="pa-6" width="830" elevation="2" v-else data-qa="noticecashisacloseaccount-card-bp0xlj">
        <p class="title font-weight-bold text-capitalized" data-qa="noticecashisacloseaccount-p-m4gsg">
          {{ text.reviewTitle }}
        </p>
        <v-container data-qa="noticecashisacloseaccount-container-em4gpi">
          <v-checkbox data-qa="noticecashisacloseaccount-checkbox-ffxqn"
            v-if="closeWithoutNotice"
            v-model="closeWithoutNotice"
            disabled
            class="mt-0 pb-4"
            :label="text.closeWithoutNotice"
          />
          <template v-else>
            <p class="mb-2" data-qa="noticecashisacloseaccount-p-p44iv8">
              {{ text.yourAccoutWouldClose }}</p>
            <p class="pl-5 mb-0 text-uppercase" data-qa="noticecashisacloseaccount-p-7gfahy">
              {{ text.noticeWthdrawalDate }}</p>
            <p class="pl-5 pb-4 font-weight-bold text-h6" data-qa="noticecashisacloseaccount-p-gx3qtt">
              {{ params.withdrawalDateDisplay }}</p>
          </template>
          <p class="mb-2" data-qa="noticecashisacloseaccount-p-0tljic">
            {{ text.reviewPayawayNote }}</p>
          <p class="pl-5 mb-0 font-weight-bold text-h6" data-qa="noticecashisacloseaccount-p-rzhh6f">
            {{ selectedPayaway.text }}</p>
          <p class="pl-5 pb-4 pt-0 font-weight-bold text-subtitle-2" data-qa="noticecashisacloseaccount-p-w02n9g">
            {{ selectedPayaway.hint }}</p>

          <template v-if="config.showReasonForClosure">
            <p class="mb-2" data-qa="noticecashisacloseaccount-p-4hqcu3">
            {{ text.reasonForClosure }}</p>
            <p class="pl-5 pb-4 font-weight-bold text-h6" data-qa="noticecashisacloseaccount-p-bfrf9n">
              {{ selectedReason.text }}</p>
          </template>
          <template v-else>
            <p class="mb-2" data-qa="noticecashisacloseaccount-p-abn5e">
              {{ text.remarks }}</p>
            <p class="pl-5 pb-4 font-weight-bold text-h6" data-qa="noticecashisacloseaccount-p-6zcljz">
              {{ remarks }}</p>
          </template>

          <v-card-actions class="justify-start pl-0" data-qa="noticecashisacloseaccount-card-actions-ls7ahl">
            <v-btn
              @click="handleCloseAccountBack"
              :color="primaryColor"
              class="text-capitalize py-2 px-4"
              outlined
              data-qa="noticecashisacloseaccount-btn-9ov5rn">
              <v-icon class="material-symbols-outlined" data-qa="noticecashisacloseaccount-icon-esy18i">arrow_left_alt</v-icon>
              {{ text.back }}
            </v-btn>
            <v-btn data-qa="noticecashisacloseaccount-btn-syshjm"
              @click="handleCloseAccountProceed"
              :color="primaryColor"
              class="text-capitalize py-2 px-4 ml-2"
              dark
              v-text="text.confirm"
            />
          </v-card-actions>
        </v-container>
      </v-card>

      <!-- Success dialog -->
      <NoticeCashIsaSuccess
        v-if="showSuccess"
        :subtitle="closeAccountText.subtitle"
        :text="closeAccountText.title"
        :view-button-text="closeAccountText.viewButtonText"
        @onViewNoticeClick="closeWithoutNotice ? gotoAccountDetails() : gotoNoticeDetails()"
        @onGotoDashboardClick="gotoDashboard"
      />

      <OtpHandler
        v-if="showOtp"
        @otp-cancelled="showOtp = false"
        @otp-success="closeAccount"
      />

      <!-- Immediate close account failure -->
      <Modal
        :config="modalConfigFailure"
        @btn2Action="gotoDashboard"
        @btn1Action="gotoNoticeDetails">
        <span slot="modalContent" class='font-weight-bold black--text' v-if="causes" data-qa="noticecashisacloseaccount-span-7a91z">
          {{$t('closeAccount.failureMessage')}}
        </span>
      </Modal>

      <NoticeCashIsaWarning
        v-if="showCloseWithoutNoticeWarning"
        :subtitle="$t('closeAccount.closeImmediately')"
        :text="text.lossOfInterestWarning"
        @onCancel="cancelCloseWithoutNotice"
        @onContinue="gotoReview"
      />
    </v-col>
  </v-row>
</template>

<script>
import commonService from '@/service/commonService.js'
import preload from '@/util/preload'

const NO_RECORDS = 'no records exist'
const NO_RECORDS_STATUS = 404

export default {
  name: 'NoticeCashIsaCloseAccount',
  components: {
    Modal: () => import('@/components/common/Modal.vue'),
    NoticeCashIsaSuccess: () => import('@/views/accounts/accountDetails/noticeCashISA/NoticeCashIsaSuccess.vue'),
    NoticeCashIsaSelectPayaway: () => import('@/views/accounts/accountDetails/noticeCashISA/NoticeCashIsaSelectPayaway.vue'),
    NoticeCashIsaCloseAccountHeader: () => import('@/views/accounts/accountDetails/noticeCashISA/NoticeCashIsaCloseAccountHeader.vue'),
    NoticeCashIsaWarning: () => import('@/views/accounts/accountDetails/noticeCashISA/NoticeCashIsaWarning.vue'),
    OtpHandler: () => import('@/components/common/OtpHandler.vue')
  },
  props: {

  },
  data () {
    return {
      params: this.$route.params,
      showOtp: false,
      showSuccess: false,
      noticeDetailsTab: 1,
      noticeListTab: 2,
      selectedPayaway: null,
      showForecast: false,
      selectedReason: '',
      closeWithoutNotice: false,
      causes: [],
      chargeDetails: {},
      showCloseWithoutNoticeWarning: false,
      reasonsForClosure: [],
      reasonsForWithdrawal: [],
      sameBankAccounts: [],
      otherBankAccounts: [],
      reasons: [],
      remarks: null,
      rules: {
        required: (v) => Boolean(v) || 'Required'
      },
      modalConfigFailure: {
        enabled: false,
        persistent: true,
        title: this.$t('closeAccount.closeAccFailed'),
        btn1Label: this.$t('noticeCashIsa.common.button.viewNoticeDetails'),
        btn2Label: this.$t('noticeCashIsa.common.button.gotoDashboard'),
        width: 600
      }
    }
  },
  mounted () {
    if (this.params.availableBalance === 0) {
      this.closeWithoutNotice = true
    }
  },
  methods: {
    handleCloseAccountBack () {
      this.showForecast = false
    },
    async gotoReview () {
      if (this.showCloseWithoutNoticeWarning) {
        this.showCloseWithoutNoticeWarning = false
        this.showForecast = true
        return
      }
      if (this.closeWithoutNotice && this.params.availableBalance > 0) {
        this.chargeDetails = await this.getChargeDetails()
        if (this.chargeDetails?.chargeAmount) {
          this.showCloseWithoutNoticeWarning = true
        } else {
          this.showCloseWithoutNoticeWarning = false
          if (this.chargeDetails?.status === NO_RECORDS_STATUS && this.chargeDetails?.title.toLowerCase() === NO_RECORDS) {
            this.showForecast = true
          }
        }
        return
      }
      this.showForecast = true
    },
    handleCloseAccountProceed () {
      if (this.config.otpRequired) {
        this.showOtp = true
        return
      }
      this.closeAccount()
    },
    gotoDashboard () {
      this.$router.push('/home')
    },
    async gotoNoticeDetails () {
      const params = this.params
      params.balance = await this.getBalance()
      params.navToTab = this.noticeListTab
      this.$router.push({
        name: 'AccountDetails',
        params: params
      })
    },
    async gotoAccountDetails () {
      const params = this.params
      params.balance = await this.getBalance()
      params.navToTab = this.noticeDetailsTab
      this.$router.push({
        name: 'AccountDetails',
        params: params
      })
    },
    async closeAccount () {
      this.showOtp = false
      if (this.closeWithoutNotice) {
        await this.closeAccountWithoutNotice()
      } else {
        await this.closeAccountWithNotice()
      }
    },
    async closeAccountWithNotice () {
      const params = this.params
      const payload = {
        noticeAmount: {
          amount: parseFloat(params.withdrawalAvailableAmount),
          currency: params.currency
        },
        withdrawalDate: params.withdrawalDate,
        otherBankAccount: this.selectedPayaway.otherBankAccount,
        payAwayaccount: this.selectedPayaway.payAwayaccount,
        payAwayBeneficiaryId: this.selectedPayaway.payawayBeneficiaryId,
        isISAOrNoticeClosure: true,
        reasonForWithdrawal: this.selectedReason.value,
        reasonForClosure: this.selectedReason.value,
        comments: this.config.showReasonForClosure ? this.selectedReason.text : this.remarks
      }

      const resp = await commonService.placeNotice(
        params.accountId,
        payload
      )
      if (resp && resp.noticeId) {
        this.showSuccess = true
      }
    },
    async closeAccountWithoutNotice () {
      const body = {
        reasonForClosure: this.selectedReason.value,
        reasonForWithdrawal: this.selectedReason.value,
        comments: this.config.showReasonForClosure ? this.selectedReason.text : this.remarks,
        payawayBeneficiaryId: this.selectedPayaway.otherBankAccount === 'YES' ? this.selectedPayaway.payawayBeneficiaryId : '',
        payawayAccountId: this.selectedPayaway.otherBankAccount === 'NO' ? this.selectedPayaway.payAwayaccount : ''
      }

      if (this.params.availableBalance > 0) {
        const charge = this.chargeDetails?.chargeAmount?.value ?? 0
        const tax = this.chargeDetails?.taxAmount?.value ?? 0
        if (charge > 0 || tax > 0) {
          body.chargeClosureDetails = {
            chargeAmount: {
              value: charge + tax,
              currency: this.chargeDetails?.chargeAmount?.currency ?? this.params.currency
            }
          }
        }
      }

      const response = await commonService.closeSavingsAccount(this.params.accountId, body)
      this.showSuccess = response?.accountId
      this.modalConfigFailure.enabled = response?.causes?.length
      this.causes = response?.causes ?? []
      if (!this.showSuccess && !this.modalConfigFailure.enabled) {
        this.dispatchError(this.text.defaultError)
      }
      await preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
    },
    async getBalance () {
      try {
        const res = await commonService.getNoticeAccountBalances(this.params.accountId)
        return res?.balanceInformation?.availableBalance ?? 0
      } catch (error) {
        console.error(error)
      }
    },
    async getReasons () {
      const code = {
        codeReferences: [{ reference: 'REASON_FOR_WITHDRAWAL' }]
      }
      const response = await commonService.getGenericCodes(code)
      const reasons = response?.aggregateCodes?.[0].codes ?? []

      this.reasons = reasons
        .filter(reason => !this.config.exludedWithdrawalReasons.includes(reason.codeReference))
        .map(reason => ({
          text: reason.codeDescription,
          value: reason.codeReference
        }))
        .sort((a, b) => a.text.localeCompare(b.text))
    },
    async getChargeDetails () {
      const response = await commonService.getNoticeLossOfInterest(this.params.accountId, this.params.availableBalance)
      if (response?.causes?.length) {
        this.dispatchError(response.causes[0].message)
      } else if (response?.data?.name === 'Error') {
        this.dispatchError(response.data.message)
      }
      return response
    },
    cancelCloseWithoutNotice () {
      this.showCloseWithoutNoticeWarning = false
    },
    dispatchError (content) {
      this.$store.dispatch('appStore/setAppData', {
        message: {
          title: 'Error',
          content,
          type: 'error',
          width: 400,
          persistent: true,
          close: true,
          component: 'dob-modal'
        }
      })
    },
    async getSameBankAccounts () {
      const response = await preload.getAllCASAWithBalance(JSON.parse(sessionStorage.getItem('username')))
      this.sameBankAccounts = response?.length ? response : []
    },
    async getBeneficiaries () {
      const response = await commonService.getBeneficiaries(JSON.parse(sessionStorage.getItem('username')))
      this.otherBankAccounts = response?.items ?? []
    }
  },
  async created () {
    if (!this.params?.accountId) {
      this.gotoDashboard()
    }
    await this.getReasons()
    await this.getSameBankAccounts()
    await this.getBeneficiaries()
  },
  computed: {
    canProceed () {
      return this.selectedPayaway && (this.selectedReason || this.remarks)
    },
    config () {
      return {
        otpRequired: this.isNoticeAccount
          ? this.$appSettings.defaultConfigurations.noticeAccountClosure.otpRequired
          : this.$appSettings.defaultConfigurations.noticeCashIsa.closeAccount.otpRequired,
        validReasons: this.$appSettings.validCloseAccountReasons,
        exludedWithdrawalReasons: this.$appSettings.uiFieldsDisplayConfigurations.noticeAccountWithdrawalReasonsList.exclusionList,
        showReasonForClosure: this.$appSettings.defaultConfigurations.noticeCashIsa.closeAccount.showReasonForClosure
      }
    },
    text () {
      return {
        viewDetails: this.$t('accountDetails.viewDetails'),
        closureTitle: this.$t('noticeCashIsa.closeAccount.card.closure.title'),
        reviewTitle: this.$t('noticeCashIsa.closeAccount.card.forecast.title'),
        closurePayawayNote: this.$t('noticeCashIsa.closeAccount.card.closure.payawayNote'),
        reviewPayawayNote: this.$t('noticeCashIsa.closeAccount.card.forecast.payawayNote'),
        yourAccoutWouldClose: this.$t('noticeCashIsa.closeAccount.card.common.yourAccountWouldClose'),
        noticeWthdrawalDate: this.$t('noticeCashIsa.closeAccount.card.common.noticeWithdrawalDate'),
        proceed: this.$t('noticeCashIsa.common.button.proceed'),
        confirm: this.$t('closeAccount.btnConfirm'),
        back: this.$t('noticeCashIsa.common.button.back'),
        succesTitle: this.$t('noticeCashIsa.closeAccount.success.subtitle'),
        otpTitle: this.$t('otp.toolBarTitle'),
        reasonForClosure: this.$t('noticeCashIsa.closeAccount.card.common.reasonForClosure'),
        remarks: this.$t('noticeCashIsa.closeAccount.card.common.remarks'),
        closeWithoutNotice: this.$t('noticeCashIsa.closeAccount.card.common.closeAccountWithoutNotice'),
        lossOfInterestWarning: this.$t('closeAccount.lossOfInterestWarning', { amount: this.chargePlusTax }),
        closedImmediately: this.$t('closeAccount.closedImmediately', { account: this.params?.product?.accountId ?? '' }),
        willBeClosedAtWithdrawal: this.$t('noticeCashIsa.closeAccount.success.text', { account: this.params?.product?.accountId ?? '' }),
        accountClosureSuccessFul: this.$t('closeAccount.accountClosureSuccessFul'),
        viewAccountDetails: this.$t('closeAccount.viewAccDetailsBtnLabel'),
        viewNoticeDetails: this.$t('placeNotice.viewNoticeDetailsBtnLabel'),
        defaultError: this.$t('systemMessages.exceptions.DEFAULT.message'),
        bullet: this.$t('closeAccount.bullet')
      }
    },
    closeAccountText () {
      return {
        subtitle: this.closeWithoutNotice ? this.text.accountClosureSuccessFul : this.text.succesTitle,
        title: this.closeWithoutNotice ? this.text.closedImmediately : this.text.willBeClosedAtWithdrawal,
        viewButtonText: this.closeWithoutNotice ? this.text.viewAccountDetails : this.text.viewNoticeDetails
      }
    },
    isNoticeAccount () {
      return this.params.accountType === 'NACC'
    },
    chargePlusTax () {
      const charge = this.chargeDetails?.chargeAmount?.value ?? 0
      const tax = this.chargeDetails?.taxAmount?.value ?? 0
      const currency = this.chargeDetails?.chargeAmount?.currency ?? ''
      return this.$formatter.currency.format(charge + tax, currency)
    },
    isBalanceZero () {
      return this.params.availableBalance === 0
    }
  }
}
</script>
